import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import {TableCell as TableCellMUI} from '@material-ui/core';
import {withStyles} from '@material-ui/core/styles';

const styles = theme => ({
	cell: {
		paddingRight: theme.spacing.unit,
		paddingLeft: theme.spacing.unit,
		'&:first-child': {
			paddingLeft: theme.spacing.unit * 3,
		},
		overflow: 'hidden',
		textOverflow: 'ellipsis',
		whiteSpace: 'nowrap',
	},
	cellRightAlign: {
		textAlign: 'right',
	},
});

const DefaultCell = ({
		column, value, children, classes,
		tableRow, tableColumn, row,
		className,
		...restProps
}) => (
	<TableCellMUI
		className={classNames({
			[classes.cell]: true,
			[classes.cellRightAlign]: tableColumn && tableColumn.align === 'right',
		}, className)}
		{...restProps}
	>
		{children || value}
	</TableCellMUI>
);

DefaultCell.propTypes = {
	value: PropTypes.any,
	column: PropTypes.object,
	row: PropTypes.object,
	classes: PropTypes.object.isRequired,
	children: PropTypes.node,
	tableRow: PropTypes.object,
	tableColumn: PropTypes.object,
	className: PropTypes.string,
};

DefaultCell.defaultProps = {
	value: undefined,
	column: undefined,
	row: undefined,
	children: undefined,
	tableRow: undefined,
	tableColumn: undefined,
	className: undefined,
};

export default withStyles(styles, {name: 'DefaultCell'})(DefaultCell);